import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";

export const CameraDropDownFrontel = ({
  showUserDropDown,
  navBarCollapsed,
}: {
  showUserDropDown: boolean;
  navBarCollapsed: boolean;
}) => {
  const navigate = useNavigate();

  const {
    cameraOptionsFrontel,
    siteOptionsFrontel,
    cameraDropDownValueFrontel,
    setCameraDropDownValueFrontel,
    setUserFiltersFrontel,
    loadingCamerasFrontel,
  } = useClipsStore();

  const cameraIds = new Map();
  (cameraOptionsFrontel || []).forEach((object: any) => {
    cameraIds.set(object.camera_name, object.id);
  });

  const siteIds = new Map();
  (siteOptionsFrontel || []).forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  // Create a Set to track unique camera names and ensure we only add each name once
  const uniqueCameraNames = new Set<string>();
  const options: string[] = [];

  // First pass: collect unique camera names
  (cameraOptionsFrontel || []).forEach((object: any) => {
    if (!uniqueCameraNames.has(object.camera_name)) {
      uniqueCameraNames.add(object.camera_name);
      options.push(object.camera_name);
    }
  });

  let sx: any;

  if (showUserDropDown && navBarCollapsed) {
    sx = { width: 175 };
  }

  if (showUserDropDown && !navBarCollapsed) {
    sx = { width: 150 };
  }

  if (!showUserDropDown && navBarCollapsed) {
    sx = { width: 235 };
  }

  if (!showUserDropDown && !navBarCollapsed) {
    sx = { width: 200 };
  }
  return (
    <div key="camera_dropdown_frontel">
      <Autocomplete
        value={cameraDropDownValueFrontel}
        disablePortal
        options={options}
        loading={loadingCamerasFrontel}
        onChange={(event, value: any) => {
          if (value !== null) {
            setCameraDropDownValueFrontel(value);
            setUserFiltersFrontel((previousState: any) => {
              return { ...previousState, camera_ids: [cameraIds.get(value)] };
            });
          } else {
            setCameraDropDownValueFrontel(value);
            setUserFiltersFrontel((previousState: any) => {
              return { ...previousState, camera_ids: [] };
            });
          }
          // TODO: Add getDownloadURLFrontel call when API function is ready
          // getDownloadURLFrontel(navigate);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Camera"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingCamerasFrontel ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={sx}
          />
        )}
      />
    </div>
  );
};
